import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import useTranslation from "next-translate/useTranslation";
import { useCallback, useMemo, useState } from "react";
import useUser from "@/common/hook/user/useUser";
import request from "@/utils/request";
import AuthTokenStore from "@/common/store/AuthTokenStore";

export default function useRegister(isConsultant = false) {
  const router = useRouter();
  const { mutate: mutateUser } = useUser(router.query.redirectTo || "/dashboard", true);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { t } = useTranslation("auth");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleData = useCallback(
    async (data) => {
      if (loading) return;

      setLoading(true);
      setError("");

      const sendData = {
        type: isConsultant ? "consultant" : "customer",
        email: data.email,
        username: data.username,
        password: data.password,
      };

      if (isConsultant) {
        sendData.forename = data.forename;
        sendData.surname = data.surname;
      }

      try {
        const {
          data: { token },
        } = await request.post("/registration", sendData);
        AuthTokenStore.set(token);
        await mutateUser();
      } catch (err) {
        if (err.response?.status === 400) {
          setError(Object.values(err.response.data.errors).join("\n"));
        } else if (err.response?.status === 422) {
          setError(err.response.data.detail);
        } else {
          console.error(err);
          setError(t`common:error.general`);
        }
      } finally {
        setLoading(false);
      }
    },
    [isConsultant, loading, mutateUser, t]
  );

  const onSubmit = useMemo(() => handleSubmit(handleData), [handleData, handleSubmit]);

  return { onSubmit, error, register, errors, loading };
}
